import { useRouteError, Link } from "react-router-dom";
import { Container } from "../../components/common/HtmlTags/Container/Container";
import { Heading } from "../../components/common/HtmlTags/Heading/Heading";
import { Paragraph } from "../../components/common/HtmlTags/Paragraph/Paragraph";

function ErrorPage() {
  const error: any = useRouteError();
  let title = "An error Occured!";
  let message = "Something went wrong!";
  if (error.status === 500) {
    message = JSON.parse(error.data).message;
  }
  if (error.status === 400) {
    title = "Not Found!";
    message = "Could not find resource or page!";
  }

  return (
    <Container>
      <Heading variant="h1">{title}</Heading>
      <Paragraph>{message}</Paragraph>
      <Link to="/">Go to Home</Link>
    </Container>
  );
}

export default ErrorPage;
